/*
* Adding custom parsley validation for phone-like fields.
* Allowed characters are:0-9 - + ( ) . space
* */
window.Parsley.addValidator('phoneFormat', {
    validateString: function (value) {
        var allowed_symbols = /^[\d\+\-\.\(\)\s]{7,20}$/;
        return allowed_symbols.test(value);
    }
});

/*
* Adding custom parsley validation for email-like fields.
* Restrict ".con"
* */
window.Parsley.addValidator('emailFormat', {
    requirementType: 'string',
    validateString: function (value) {
        return !value.trim().endsWith('.con');
    }
});